import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'

const vuexLocal = new VuexPersistence({
  storage: window.localStorage
})
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    list: null,
    winners: [],
    confirmingWinner: null,
    totalPrize: 0
  },
  mutations: {
    ['CLEAR_WINNERS'] (state) {
      state.winners = []
      state.totalPrize = 0
    },
    ['ADD_WINNER'] (state, obj) {
      state.winners.unshift(obj)
    },
    ['CLEAR_CONFIRMING'] (state) {
      state.confirmingWinner = null
    },
    ['ADD_CONFIRMING'] (state, obj) {
      state.confirmingWinner = obj
    },
    ['ADD_PRIZE_AMOUNT'] (state, value) {
      state.totalPrize += value
    },
    ['SAVE_LIST'] (state, data) {
      state.list = data
    },
    ['REMOVE_ITEM_FROM_LIST'] (state, obj) {
      state.list = state.list.filter(function(el) {
        return el.number !== obj.number;
      });
    },
  },
  actions: {
    saveList ({commit}, obj) {
      commit('SAVE_LIST', obj)
    },
    addConfirming({commit}, obj) {
      commit('ADD_CONFIRMING', obj)
    },
    clearConfirming ({commit}) {
      commit('CLEAR_CONFIRMING')
    },
    addWinner ({commit}, obj) {
      commit('ADD_WINNER', obj)
    },
    addPrizeAmount ({commit}, value) {
      commit('ADD_PRIZE_AMOUNT', value)
    },
    clearWinners ({commit}) {
      commit('CLEAR_WINNERS')
    },
    removeItemFromList({commit}, obj) {
      commit('REMOVE_ITEM_FROM_LIST', obj)
    }
  },
  modules: {
  },
  plugins: [vuexLocal.plugin]
})
